var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 100,
    viewBox: "0 0 76 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 28.125V87.5C75.5 90.8152 74.183 93.9946 71.8388 96.3388C69.4946 98.683 66.3152 100 63 100H13C9.68479 100 6.50537 98.683 4.16116 96.3388C1.81696 93.9946 0.5 90.8152 0.5 87.5V12.5C0.5 9.18479 1.81696 6.00537 4.16116 3.66117C6.50537 1.31696 9.68479 0 13 0L47.375 0L75.5 28.125ZM56.75 28.125C54.2636 28.125 51.879 27.1373 50.1209 25.3791C48.3627 23.621 47.375 21.2364 47.375 18.75V6.25H13C11.3424 6.25 9.75268 6.90848 8.58058 8.08058C7.40848 9.25268 6.75 10.8424 6.75 12.5V87.5C6.75 89.1576 7.40848 90.7473 8.58058 91.9194C9.75268 93.0915 11.3424 93.75 13 93.75H63C64.6576 93.75 66.2473 93.0915 67.4194 91.9194C68.5915 90.7473 69.25 89.1576 69.25 87.5V28.125H56.75Z",
    fill: "#98A6AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.c795dcfb0ce97a7a4250c50b3fa32aa4.svg";
export { ForwardRef as ReactComponent };